// import { BootcampProductAPIStat, BootcampProductUIStat } from '~/redux/apis/user-stats-api'
import { ArticleProductAPIStat, CurriculumArticleProductUIStat } from '~/redux/apis/user-stats-api'
import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'

export default function useArticleProductCardStats(productStat: ArticleProductAPIStat): CurriculumArticleProductUIStat {
  const {
    subjectTitle,
    title,
    id,
    timeSpent,
    summary: { totalSetsCount, setsCompletedCount, totalCorrectAnswersCount, totalIncorrectAnswersCount },
    path,
    articleRead,
  } = productStat

  const { days: timeSpentDays, hours: timeSpentHours, minutes: timeSpentMinutes } = convertMsToDayHourMinute(timeSpent)
  const correctAnswerPercentage = Math.floor(
    (totalCorrectAnswersCount / (totalCorrectAnswersCount + totalIncorrectAnswersCount)) * 100,
  )
  const activitySetsProgress = Math.floor((setsCompletedCount / totalSetsCount) * 100)

  const formatCorrectAnswerPercentage = isNaN(correctAnswerPercentage) ? 0 : correctAnswerPercentage
  const totalAnswered = totalCorrectAnswersCount + totalIncorrectAnswersCount

  return {
    id,
    subjectTitle,
    title,
    timeSpent: {
      days: timeSpentDays,
      hours: timeSpentHours,
      minutes: timeSpentMinutes,
    },
    activitiesSummary: {
      totalSetsCount,
      setsCompletedCount,
    },
    totalAnswered,
    correctAnswerPercentage: formatCorrectAnswerPercentage,
    path,
    articleRead,
    activitySetsProgress,
  }
}
